var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface / Log_Out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 12.4997L12.5 9.99967M12.5 9.99967L10 7.49967M12.5 9.99967H3.33337M7.50004 6.04016V5.99984C7.50004 5.06642 7.50004 4.59936 7.6817 4.24284C7.84149 3.92924 8.09627 3.67445 8.40987 3.51466C8.76639 3.33301 9.23345 3.33301 10.1669 3.33301H14.0002C14.9336 3.33301 15.3997 3.33301 15.7562 3.51466C16.0698 3.67445 16.3254 3.92924 16.4852 4.24284C16.6667 4.59901 16.6667 5.0655 16.6667 5.9971V14.0027C16.6667 14.9343 16.6667 15.4001 16.4852 15.7562C16.3254 16.0698 16.0698 16.3251 15.7562 16.4849C15.4 16.6663 14.9342 16.6663 14.0026 16.6663H10.1641C9.23254 16.6663 8.76604 16.6663 8.40987 16.4849C8.09627 16.3251 7.84149 16.0696 7.6817 15.756C7.50004 15.3995 7.50004 14.9331 7.50004 13.9997V13.958",
    stroke: "#282A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/Log_Out.4da768c78335a81e1072499f599ffd83.svg";
export { ForwardRef as ReactComponent };